import { storiesReachConfig } from '@/lib/analytics/kpis/instagram/stories/storiesReach';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const storiesReachMVConfig = {
    ...storiesReachConfig,
    name: 'kpi.instagram.stories.stories_reach',
    id: 'reach',
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
